import { render, staticRenderFns } from "./snackbar-messages.vue?vue&type=template&id=0c668a69&scoped=true&"
import script from "./snackbar-messages.vue?vue&type=script&lang=js&"
export * from "./snackbar-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c668a69",
  null
  
)

export default component.exports